import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBase from "services/principal/customFetchBase";

export const nivelEstudioApi = createApi({
  reducerPath: "nivelEstudioApi",
  baseQuery: customFetchBase,
  tagTypes: ["NivelEstudio"],
  endpoints: (builder) => ({
    getNivelesEstudio: builder.query({
      query: () => ({
        url: "/v1/api/niveldeestudios/",
        method: "GET",
      }),
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({
                type: "NivelEstudio",
                id,
              })),
              { type: "NivelEstudio", id: "LIST" },
            ]
          : [{ type: "NivelEstudio", id: "LIST" }],
    }),
    getNivelEstudio: builder.query({
      query: (id) => ({
        url: `/v1/api/niveldeestudios/${id}/`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "NivelEstudio", id }],
    }),
  }),
});

export const { useGetNivelesEstudioQuery, useGetNivelEstudioQuery } =
  nivelEstudioApi;
